import SharedPreferences from "../../constants/SharedPreferences";
import {
  getFromStorage,
  clearStorage,
} from "../../util/Utility";
import BayunError from "../../constants/BayunError";
import Constants from "../../constants/Constants";
import { AuthenticateResponse } from "../../BayunCore";
import { validateSecurityQuestionsPassphraseDialog } from "./internal/twoFaDialogUi";
export const completeReauthenticationWithPassphraseOrSQ = async (
  sessionId,
  bayunCore,
  successCallback,
  failureCallback,
  securityQuestionsCallback,
  passphraseCallback,
) => {
  console.log("completeReauthenticationWithPassphraseOrSQ");
  // for reauthentication, return the verify status according to MFA setting
  const mfaSetting = await getFromStorage(
    sessionId,
    SharedPreferences.MFA_SETTING,
  );

  // if it has passcode, take passcode and continue, no need to wait
  if (mfaSetting == Constants.MULTI_FACTOR_SINGLE_FA_WITH_PASSCODE) {
    successCallback({
      sessionId,
      securityQuestions: null,
      authenticationResponse: AuthenticateResponse.SUCCESS,
    });
  } else {
    var securityQuestions;
    const securityQuestionsString = await getFromStorage(
      sessionId,
      SharedPreferences.SECURITY_QUESTIONS,
    );
    if (securityQuestionsString) {
      securityQuestions = JSON.parse(securityQuestionsString);
    }

    if (securityQuestions === undefined) {
      //review
      clearStorage(sessionId);
      failureCallback(BayunError.ERROR_REAUTHENTICATION_NEEDED);
    }

    let isPassphraseActive = false;
    if (
      mfaSetting ==
      Constants.MULTI_FACTOR_SINGLE_FA_WITH_SECURITY_QUESTIONS_AND_PASSPHRASE ||
      mfaSetting ==
      Constants.MULTI_FACTOR_TWO_FACTOR_AUTHENTICATION_WITH_PASSPHRASE
    ) {
      isPassphraseActive = true;
    }

    if (!isPassphraseActive && securityQuestions === undefined) {
      //review
      clearStorage(sessionId);
      failureCallback(BayunError.ERROR_REAUTHENTICATION_NEEDED);
    }
    if (passphraseCallback == null && securityQuestionsCallback == null) {
      validateSecurityQuestionsPassphraseDialog(
        sessionId,
        bayunCore,
        securityQuestions,
        isPassphraseActive,
        null,
        null,
        null,
        successCallback,
        failureCallback,
        null,
      );
    } else {
      // return the status to verify SQ or passphrase
      if (isPassphraseActive) {
        passphraseCallback({
          sessionId,
          securityQuestions: null,
          authenticationResponse: AuthenticateResponse.VERIFY_PASSPHRASE,
        });
      } else {
        securityQuestionsCallback({
          sessionId,
          securityQuestions,
          authenticationResponse:
            AuthenticateResponse.VERIFY_SECURITY_QUESTIONS,
        });
      }
    }
  }
};